<div class="my-4 flex break-inside-avoid-page items-center rounded bg-steel-5 p-4">
  <rma-profile-avatar
    class="mr-4 h-20 w-20 shrink-0"
    [name]="report.profile.fullName"
    [avatar]="report.profile.avatarImage"
    [backgroundColour]="report.profile.backgroundColour"
    [lazyLoad]="false"
  />

  <div class="mr-4 w-full wrap-normal">
    <p class="bold leading-tight mb-1 text-lg">
      {{ report.profile.fullName }} {{ report.profile.agentTitle ? '-' : '' }} {{ report.profile.agentTitle }}
    </p>
    @if (report.profile.fullName !== report.profile.agencyName) {
      <p class="mb-1 text-steel-70">{{ report.profile.agencyName }}</p>
    }
    <div class="mb-1 flex items-center">
      @if ((report.profile.agentCode && (report.profile.agentOverallStars ?? 0 > 0)) || (report.profile.agencyOverallStars ?? 0 > 0)) {
        <rma-star-rating-summary
          class="mr-2"
          [overallStars]="report.profile.agentCode ? report.profile.agentOverallStars : report.profile.agencyOverallStars"
        />
      }
      @if (report.profile.reviewCount) {
        <span>
          {{ 'review.count' | transloco: { count: report.profile.reviewCount } }}
        </span>
      }
      <rma-market-report-top-award class="ml-2" [awards]="report.agentAwards ?? report.agencyAwards" />
    </div>
  </div>

  <img alt="" class="h-24 w-24" [src]="report.qrCodeDataUri" />
</div>

@if (report.profile.email || report.profile.agencyAddress || report.profile.contactNumber) {
  <div class="my-4 break-inside-avoid-page rounded bg-steel-5 p-4">
    <p class="mb-4"><strong>Contact details</strong></p>
    @if (report.profile.agencyAddress) {
      <p class="mb-1 flex items-center">
        <rma-icon class="mr-2 text-steel-70" glyph="location_on" />
        {{ report.profile.agencyAddress }}
      </p>
    }
    @if (report.profile.email) {
      <p class="mb-1 flex items-center">
        <rma-icon class="mr-2 text-steel-70" glyph="email" />
        {{ report.profile.email }}
      </p>
    }
    @if (report.profile.contactNumber) {
      <p class="mb-1 flex items-center">
        <rma-icon class="mr-2 text-steel-70" glyph="phone" />
        {{ report.profile.contactNumber }}
      </p>
    }
  </div>
}

@if (messageParagraphs) {
  <div class="my-4 p-4">
    <div class="whitespace-pre-wrap">
      @for (paragraph of messageParagraphs; track paragraph; let i = $index) {
        <div class="mb-4 break-inside-avoid whitespace-pre-wrap">
          {{ paragraph }}
          @if (i + 1 === messageParagraphs.length) {
            <div class="mt-4 font-bold">
              {{ report.profile.fullName }} {{ report.profile.agentTitle ? '-' : '' }} {{ report.profile.agentTitle }}
            </div>
            @if (report.profile.fullName !== report.profile.agencyName) {
              <div class="font-bold">{{ report.profile.agencyName }}</div>
            }
          }
        </div>
      }
    </div>
  </div>
}
